/**
 * @borradh-workspace/api-client - Graphics API Types
 *
 * Types for the graphics API endpoints. Derived from the features package.
 *
 * The Canva-era endpoints (create-graphic, render-graphic, search-stock-images,
 * legacy slide CRUD) and the Fabric scene editor (GET/PATCH /graphics/:id/scene)
 * have been removed. The live surface is:
 *   - POST /graphics/generate         — AI generate-from-service flow
 *   - GET  /graphics                  — list
 *   - GET  /graphics/:id              — read
 *   - PATCH /graphics/:id             — update mutable metadata
 *   - DELETE /graphics/:id            — delete
 */
import { ErrorCodes, IMAGE_SAFETY_BLOCK_USER_MESSAGE, graphicCategoryLabels, graphicCategoryValues, graphicStatusLabels, graphicStatusValues, } from '@borradh-workspace/features/shared';
export { graphicStatusLabels, graphicStatusValues, graphicCategoryLabels, graphicCategoryValues, };
// ============================================================================
// FAILURE CODES — the stable GFX-xxxx codes persisted on a failed graphic
// ============================================================================
/**
 * Re-exported from the features package's frontend-safe entry point, so the
 * dashboard reacts to a specific failure (e.g. a safety block) without
 * copying the code strings.
 */
export { GraphicGenerationErrorCodes, GraphicGenerationErrorMessages, } from '@borradh-workspace/features/graphics/errors';
/**
 * The feature error code a synchronous image tool returns when the provider's
 * safety checks blocked the image (the website builder's `generate_image`).
 * The asynchronous graphics pipeline persists
 * `GraphicGenerationErrorCodes.MODEL_SAFETY_BLOCKED` instead.
 */
export const IMAGE_SAFETY_BLOCKED_ERROR_CODE = ErrorCodes.AI_SAFETY_BLOCKED;
export { IMAGE_SAFETY_BLOCK_USER_MESSAGE };
//# sourceMappingURL=graphics.js.map